export default function MySQL_FROM_DAYS() {
  return (
    <div>
      <h2>MySQL_FROM_DAYS</h2>    </div>
  );
}